import { Action } from '@/_core/fluxstore/types';
import { CurrentUserState } from '../types';
import { useCurrentUserModule } from '../useModule';
import { useSendCommand } from '@/_core/cqrs/use';
import { DeleteWsMemberJiraAuthToken } from '@/api/currentUser/commands';

const { registerMiddleware, registerReducer } = useCurrentUserModule();

export class DeleteJiraAuthToken extends Action<CurrentUserState> {
    public static ACTION_TYPE = 'DeleteJiraAuthToken';
    public constructor() {
        super(DeleteJiraAuthToken.ACTION_TYPE);
    }
}

const middleware = async (state: CurrentUserState, action: DeleteJiraAuthToken): Promise<boolean> => {
    return await useSendCommand(action, {
        createCommand: () => new DeleteWsMemberJiraAuthToken(),
    });
};

const reducer = (state: CurrentUserState): void => {
    state.hasJiraAuthToken = false;
};

//@ts-ignore
registerMiddleware(DeleteJiraAuthToken.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(DeleteJiraAuthToken.ACTION_TYPE, reducer);
